var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 12.5156C12.6578 12.5156 12.0533 12.7822 11.5911 13.2L5.25333 9.51111C5.29778 9.30667 5.33333 9.10222 5.33333 8.88889C5.33333 8.67556 5.29778 8.47111 5.25333 8.26667L11.52 4.61333C12 5.05778 12.6311 5.33333 13.3333 5.33333C14.8089 5.33333 16 4.14222 16 2.66667C16 1.19111 14.8089 0 13.3333 0C11.8578 0 10.6667 1.19111 10.6667 2.66667C10.6667 2.88 10.7022 3.08444 10.7467 3.28889L4.48 6.94222C4 6.49778 3.36889 6.22222 2.66667 6.22222C1.19111 6.22222 0 7.41333 0 8.88889C0 10.3644 1.19111 11.5556 2.66667 11.5556C3.36889 11.5556 4 11.28 4.48 10.8356L10.8089 14.5333C10.7644 14.72 10.7378 14.9156 10.7378 15.1111C10.7378 16.5422 11.9022 17.7067 13.3333 17.7067C14.7644 17.7067 15.9289 16.5422 15.9289 15.1111C15.9289 13.68 14.7644 12.5156 13.3333 12.5156Z",
    fill: "#898989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.6bf11ba5adb98a7084d658e6cdfbb355.svg";
export { ForwardRef as ReactComponent };